import { Component } from "react";
import { format } from "./messages";

// A class component because React has no hook for catching render errors.
export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Render error", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        role="alert"
        className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 text-center"
      >
        <h1 className="text-lg font-semibold text-[#0A2540]">
          {format("error_boundary.title")}
        </h1>
        <p className="mt-2 text-sm text-slate-500">{format("error_boundary.body")}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 rounded-xl bg-[#0A4730] px-4 py-2 text-sm font-semibold text-white"
        >
          {format("error_boundary.reload")}
        </button>
      </div>
    );
  }
}
